// Helper functions
export const handleErrors = (error: any) => {
  if (error.response && error.response.data) {
    return error.response.data.message || 'An error occurred';
  }
  return 'Network error';
};
export const composeThunkAction = (path: string, subPath: string) => {
  //will add '/' in between and return ex: auth/signin
  return path + "/" + subPath
}
export const convertUTCToLocalTime = (utcDateString: string) => {
  const utcDate = new Date(utcDateString);
  const addLeadingZero = (value: number) => {
    return value < 10 ? `0${value}` : value.toString();
  };
  const day = addLeadingZero(utcDate.getDate());
  const month = addLeadingZero(utcDate.getMonth() + 1);
  const year = utcDate.getFullYear();
  const hours = addLeadingZero(utcDate.getHours());
  const minutes = addLeadingZero(utcDate.getMinutes());
  const seconds = addLeadingZero(utcDate.getSeconds());
  const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  return formattedDate;
};

export const getStatusClass = (status: any) => {
  switch (status) {
    case 'BOOKED':
      return 'status-booked'; // Green color
    case 'ANSWERED':
      return 'status-answered'; // Blue color
    case 'TRANSFERRED':
      return 'status-transferred'; // Yellow color
    case 'ERROR':
      return 'status-error'; // Red color
    default:
      return '';
  }
};